import { ApplicationConfig } from '@angular/core';
import { provideRouter, withEnabledBlockingInitialNavigation, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import Aura from '@primeng/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { environment } from './environments/environment';

import { provideFirebaseApp } from '@angular/fire/app';
import { initializeApp } from 'firebase/app';

import { provideAuth } from '@angular/fire/auth';
import { getAuth } from 'firebase/auth';

import { provideFirestore } from '@angular/fire/firestore';
import { getFirestore } from 'firebase/firestore';

import { provideStorage } from '@angular/fire/storage';
import { getStorage } from 'firebase/storage';

import { MessageService } from 'primeng/api';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }), withEnabledBlockingInitialNavigation()),
    provideHttpClient(withFetch()),
    provideAnimationsAsync(),
    providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } }),
    provideClientHydration(),

    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),

    MessageService,
  ]
};
